import { render } from "./Clienti.vue?vue&type=template&id=e7424910&scoped=true&ts=true"
import script from "./Clienti.vue?vue&type=script&lang=ts"
export * from "./Clienti.vue?vue&type=script&lang=ts"

import "./Clienti.vue?vue&type=style&index=0&id=e7424910&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_entasys/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7424910"]])

export default __exports__